// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__FdFYM","log":"ModalInventoryLogs_log__f475p","date":"ModalInventoryLogs_date__2x805","userName":"ModalInventoryLogs_userName__26vZP"};